<template>
<div>
    <card>
        <template slot="header">
            <i class="material-icons">lock</i>
            <strong class="ml-2">Unauthorized</strong>
        </template>

        <template slot="body">
            You do not have the proper permissions to view this page.
            <br /><br />
            Please press <router-link to="/">here</router-link> to go home.
        </template>
    </card>
</div>
</template>

<script>
export default {
    name: "unauthorized-page"
}
</script>



// WEBPACK FOOTER //
// src/pages/UnauthorizedPage.vue